import { Route } from '@angular/router';

import { AppSettingsAndAuthGuard } from '@bms-client/store';

import { DefaultComponent } from './layouts/default/default.component';
import { EmptyComponent } from './layouts/empty/empty.component';

export const appRoutes: Route[] = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'login',
        title: 'Anmeldung',
        component: EmptyComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: 'dashboard',
        title: 'Dashboard',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
    {
        path: 'structure',
        title: 'Struktur',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/structure/structure.module').then((m) => m.StructureModule),
    },
    {
        path: 'capabilities',
        title: 'Fachkapazitäten',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/capabilities/capabilities.module').then((m) => m.CapabilitiesModule),
    },
    {
        path: 'patient-visits',
        title: 'Patientendaten',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/patient-visits/patient-visits.module').then((m) => m.PatientVisitsModule),
    },
    {
        path: 'base-data',
        title: 'Stammdaten',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/base-data/base-data.module').then((m) => m.BaseDataModule),
    },
    {
        path: 'blockages',
        title: 'Sperrungen',
        component: DefaultComponent,
        canActivate: [AppSettingsAndAuthGuard],
        loadChildren: () => import('./pages/blockages/blockages.module').then((m) => m.BlockagesModule),
    },
];
